import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { MouseEventHandler, ReactNode, forwardRef } from "react";

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: FontAwesomeIconProps["icon"];
  customIcon?: ReactNode;
  iconSize?: FontAwesomeIconProps["size"];
  color?: string;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  size?: "small" | "medium" | "large";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    {
      icon,
      customIcon,
      iconSize,
      onClick,
      color = "text-primary-500 border-primary-500",
      type = "button",
      size = "large",
      ...props
    },
    ref,
  ) {
    const sizeClasses = {
      small: "w-8 h-8",
      medium: "w-9 h-9",
      large: "w-11 h-11",
    };

    return (
      // You may be itching to reorder the props for this button, but please don't! The order is important for the way the button is styled and how it behaves.

      <button
        ref={ref}
        type={type}
        onClick={onClick}
        {...props}
        className={classNames(
          "rounded border transition-colors duration-200 hover:bg-primary-50",
          color,
          sizeClasses[size],
        )}
      >
        {!!customIcon && (
          <span className="flex justify-center items-center h-full">
            {customIcon}
          </span>
        )}
        {!!icon && <FontAwesomeIcon icon={icon} size={iconSize} />}
      </button>
    );
  },
);
